import { Ban } from "lucide-react"

interface Props {
  search?: string
  message?: string
}

const Empty: React.FC<Props> = ({ search, message = "No results found" }) => {
  return (
    <div className="flex flex-col gap-3 items-center justify-center h-full py-6">
      <Ban size={35} className="text-legacy-light" />
      {!!search ? (
        <p className="text-xs text-legacy-light">
          No results found for <b>"{search}"</b>
        </p>
      ) : (
        <p className="text-sm text-legacy-light">{message}</p>
      )}
    </div>
  )
}

export default Empty
